<template>
	<div>
		<AIRBUSMSMALS v-if="item.template == 'AIRBUS_MSM_ALS'" :exibeStatus="exibeStatus" :desativar="desativar" :editar="editar" :item="item" @click-editar="(item) => levantaEvento(item)" :exibeLegenda="exibeLegenda" />
		<AIRBUSAMM v-if="item.template == 'AIRBUS_AMM'" :exibeStatus="exibeStatus" :desativar="desativar" :editar="editar" :item="item" @click-editar="(item) => levantaEvento(item)" :exibeLegenda="exibeLegenda" />
		<ADEASBASB v-if="item.template == 'AD_EASB_ASB'" :exibeStatus="exibeStatus" :desativar="desativar" :editar="editar" :item="item" @click-editar="(item) => levantaEvento(item)" :exibeLegenda="exibeLegenda" />
		<SAFRANMM v-if="item.template == 'SAFRAN_MM'" :exibeStatus="exibeStatus" :desativar="desativar" :editar="editar" :item="item" @click-editar="(item) => levantaEvento(item)" :exibeLegenda="exibeLegenda" />
	</div>
</template>

<script>
import ADEASBASB from './templates/AD_EASB_ASB.vue'
import AIRBUSAMM  from './templates/AIRBUS_AMM.vue'
import AIRBUSMSMALS  from './templates/AIRBUS_MSM_ALS.vue'
import SAFRANMM from './templates/SAFRAN_MM.vue'

export default {

	components: {
		ADEASBASB,
		AIRBUSAMM,
		AIRBUSMSMALS,
		SAFRANMM
	},

	props: {

		item: {
			type: Object,
			required: true,
		},

		categoria: {
			type: Object,
			required: false,
		},

		editar: {
			type: Boolean,
			required: false,
			default: true,
		},


		desativar: {
			type: Boolean,
			required: false,
			default: false,
		},


		exibeLegenda: {
			type: Boolean,
			required: true,
		},

		exibeStatus: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	methods: {
		levantaEvento(item){
			this.$emit('click-editar', item, this.categoria)
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/modelo/lista.vue